export const AgeRanges = [
  {
    id: null,
    name: 'All',
    label: 'All age ranges',
  },
  {
    id: 1,
    name: 'Infant',
    label: '0 - 12 months',
    monthsFrom: 0,
    monthsTo: 12,
  },
  {
    id: 6,
    name: 'Toddler',
    label: '1 - 2 years',
    monthsFrom: 12,
    monthsTo: 24,
  },
  {
    id: 9,
    name: 'Twoddler',
    label: '2 - 3 years',
    monthsFrom: 24,
    monthsTo: 36,
  },
  {
    id: 7,
    name: 'Preschool',
    label: '3 - 4 years',
    monthsFrom: 36,
    monthsTo: 48,
  },
  {
    id: 8,
    name: 'Kindergarten',
    label: '4 - 5 years',
    monthsFrom: 48,
    monthsTo: 60,
  },
  {
    id: 5,
    name: 'School Age',
    label: '5+ years',
    monthsFrom: 60,
    monthsTo: 216,
  },
];
